<template>
  <v-dialog v-model="model"
            class="fin-video-dialog"
            :width="videoDialogWidth">
    <div v-if="model"
         class="video-container"
         :style="'display: inline-block; vertical-align: top; width: 100%; background-color:' + $finColors.accentGray1">
      <div class="text-right">
        <v-btn @click="closeDialog" class="fin-icon-close" icon>
          <v-icon>icon-close</v-icon>
        </v-btn>
      </div>
      <slot>
        <fin-video-player v-if="src"
                          :src="src"
                          :videoPlayerWidthForBreakpoints="{xs: 335, sm: 585, md: 665, lg: 796, xl: 796}"/>
      </slot>
    </div>
  </v-dialog>
</template>

<script>
import FinVideoPlayer from "@/components/common/videoPlayer"

export default {
  name: "fin-video-dialog",
  components: {
    FinVideoPlayer
  },
  props: {
    /**
     * Model of the dialog
     */
    value: {
      type: Boolean,
      required: true
    },
    /**
     * IMPORTANT!
     * For Youtube-Videos always use the embed-URL, not the normal browser-URL!
     */
    src: {
      type: [String, Object]
    }
  },
  data() {
    return {
      dialog: false,
      /**
       * Dialog width adjusts automatically
       */
      videoDialogWidth: "800px"
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit("input", newVal)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.fin-video-dialog {
  z-index: 9999;
}
</style>
